import { React, i18n, inject, pr, ui } from "aaa";
import { MessageScreen } from "../common/MessageScreen";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { amountToCurrencyString } from "types/amount";
import { QuickDrawdownStore } from "./QuickDrawdownStore";
import { numberToCurrencyString } from "util/helpers";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: QuickDrawdownStore;
}

@i18n.injectIntl
@inject("externalInterfaceStore", "authStore")
export class QuickDrawdownSuccess extends React.Component<IProps & i18n.InjectedIntlProps, {}> {
    render() {
        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                title={ui.__("quickDrawdown.summary.title")}
                message={ui.__("quickDrawdown.success.message", {
                    amount: numberToCurrencyString(this.props.store.amount),
                    iban: this.props.store.cardStore.card ? this.props.store.cardStore.card.directDebitAccount!.iban : "-"
                })}
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess("quickDrawdown")}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/quickDrawdown/QuickDrawdownSuccess.tsx